import React, { Fragment } from "react";
import GenericHeader from "../../common/Header";

class HeaderLayout extends React.Component {
  state = {};
  constructor() {
    super();

    this.headerLayout = [
      {
        label: {
          value: "Vendor",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "vendor",
          autoFocus: true,
          onBlur: "lookup",
          hotMod: false
        },
        size: "calc(50% / 3)"
      },
      {
        label: {
          value: "Vendor Name",
          size: "auto",
          fontSize: "98%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "vendName"
        },
        readOnly: true,
        size: "calc(100% / 3)"
      },
      {
        label: {
          value: "Master",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "VMASTER"
        },
        readOnly: true,
        size: "calc(50% / 3)"
      },
      {
        label: {
          value: "Vendor Name",
          size: "auto",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "masterVendor"
        },
        readOnly: true,
        size: "calc(100% / 3)"
      },
      {
        label: {
          value: "AP Ref",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "apRefNo"
        },
        readOnly: true,
        size: "calc(50% / 3)"
      },

      {
        label: {
          value: "UPC",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "upcNumber"
        },
        readOnly: true,
        size: "calc(50% / 3)"
      },

      {
        label: {
          value: "Fax Number",
          size: "50%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "faxNumber"
        },
        readOnly: true,
        size: "calc(50% / 3)"
      },
      {
        label: {
          value: "Customer Service",
          size: "auto",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "phoneNumber"
        },
        readOnly: true,
        size: "calc(100% / 3)"
      },
      {
        label: {
          value: "Intl Fax",
          size: "50%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "intFaxNumber"
        },
        readOnly: true,
        size: "calc(50% / 3)"
      }
    ];
  }
  componentDidMount() {
    this.setState({ layout: this.headerLayout });
  }

  formatData = props => {
    if (props) {
      this.headerLayout.map((layout, key) => {
        if (layout.item.intemName === props[key].name) {
          layout.item.value =
            props[key].value === undefined ||
            props[key].value === "" ||
            props[key].value === false
              ? ""
              : props[key].value;
          layout.item.obj = props[key].obj;
          layout.item.span = props[key].span;
          layout.label.value = props[key].label;
        }
        return null;
      });
    }

    return null;
  };
  getHeaderInfo = info => {
    this.props.setHeaderInfo({ header: info });
  };
  renderHeader = () => {
    this.formatData(this.props.headerData);
    return (
      <GenericHeader
        jsonObj={this.state.layout}
        setHeaderInfo={this.getHeaderInfo}
        functions={{
          lookup: this.props.lookup,
          setErrorMessage: this.props.setErrorMessage,
          setSuccessMessage: this.props.setSuccessMessage
        }}
      />
    );
  };

  getTheJson = () => {
    for (let index = 0; index < this.headerLayout.length; index++) {
 
    }
  };

  render() {
    return (
      <Fragment>
        {/* <button onClick={e => this.getTheJson()} /> */}
        {this.renderHeader()}
      </Fragment>
    );
  }
}
export default HeaderLayout;
